import { CartLinesUpdateEvent } from '@shopify/events';

const LEGACY_SUCCESS_EVENTS = ['cart:updated', 'ajaxProduct:added', 'rd:cart:add-success'];
let activeRefresh = null;
let lastRequestAt = 0;

function cartUrl() {
  return `${window.Shopify?.routes?.root || '/'}cart.js`;
}

function normalizeCart(cart) {
  return CartLinesUpdateEvent.createCartFromAjaxResponse(cart);
}

function announceSuccessfulAdd({ variantId = '', quantity = 1, source = 'custom-add-to-cart' } = {}) {
  const customDrawerTrigger = document.querySelector('[data-raj-cart-trigger]');
  const customDrawer = document.querySelector('[data-raj-cart-drawer]');

  if (customDrawerTrigger && customDrawer) {
    customDrawerTrigger.click();
    return Promise.resolve();
  }

  const now = Date.now();

  if (activeRefresh && now - lastRequestAt < 250) return activeRefresh;
  lastRequestAt = now;

  const deferred = CartLinesUpdateEvent.createPromise();
  const eventTarget = document.querySelector('cart-drawer-component') || document.body;

  eventTarget.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: source,
      lines: variantId
        ? [{ merchandiseId: String(variantId), quantity: Number(quantity) || 1 }]
        : [],
      promise: deferred.promise,
    })
  );

  activeRefresh = fetch(cartUrl(), {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  })
    .then((response) => {
      if (!response.ok) throw new Error(`Cart refresh failed: ${response.status}`);
      return response.json();
    })
    .then((cart) => {
      deferred.resolve({
        cart: normalizeCart(cart),
        detail: {
          didError: false,
          items: cart.items || [],
          itemCount: Number(quantity) || 1,
          source,
          sourceId: String(variantId || ''),
        },
      });
      return cart;
    })
    .catch((error) => {
      deferred.reject(error);
      throw error;
    })
    .finally(() => {
      activeRefresh = null;
    });

  return activeRefresh;
}

window.RDOpenCartDrawer = announceSuccessfulAdd;

for (const eventName of LEGACY_SUCCESS_EVENTS) {
  document.addEventListener(eventName, (event) => {
    announceSuccessfulAdd({
      variantId: event.detail?.variantId || event.detail?.id || '',
      quantity: event.detail?.quantity || 1,
      source: eventName,
    }).catch((error) => console.warn('[rd-cart-drawer] Unable to refresh cart drawer.', error));
  });
}
